<template>
    <MarkerContainer isStamp isAddButton @click:marker="addShift" />
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import Planbord from '@/components/Planbord.vue';
    import MarkerContainer from '@/components/Planbord/MarkerContainer.vue';

    @Component({
        components: {
            MarkerContainer,
        },
    })
    export default class StampShiftAddButton extends Vue {
        @Prop({type: Number, required: true}) public horizontalPosition!: number;
        @Prop({type: Number, required: true}) public verticalPosition!: number;
        @Prop({type: Number, required: true}) public shiftIndex!: number;

        public addShift(): void {
            /** @see Planbord.setActiveCell() */
            // @ts-expect-error TS2339
            Planbord.__vfdConstructor.setActiveCell(this.horizontalPosition, this.verticalPosition, true, true, this.shiftIndex);
        }
    }
</script>
